import React from "react";
import { Link } from "gatsby";

import RedistrictingStatus from "./RedistrictingStatus";
import DistrictMaps from "@components/DistrictPlans/DistrictMaps";
import RenderLinkGroups from "@components/DocumentGroup/RenderLinkGroups";

const HomePageBody = ({ data }) => {
	const {
		historyHeading,
		historyText,
		statusHeading,
		statusText,
		timelineItems,
		timelineHeading,
		backgroundHeading,
		backgroundText,
		additionalInformationGroups,
		maps,
	} = data;

	const colSpan =
		additionalInformationGroups.length > 4
			? 4
			: 12 / additionalInformationGroups.length;

	return (
		<>
			<h1 className="sr-only">Home</h1>
			<div className="w-100">
				<div className="row">
					<div className="col-lg mr-lg-3">
						<RedistrictingStatus
							statusHeading={statusHeading}
							statusText={statusText}
							events={timelineItems}
							timelineHeading={timelineHeading}
						/>
					</div>
					<div className="col-lg ml-lg-3">
						<h2 id="district-plans-header">District Plans</h2>
						<DistrictMaps
							maps={maps}
							additionalMapsLink={
								<Link
									className="text-light"
									to="/district-plans#districts-final"
								>
									2021 District PDF Maps
								</Link>
							}
						/>
					</div>
				</div>
				{backgroundHeading}
				{backgroundText}
				{historyHeading}
				{historyText}
				<h2 id="additional-information-header">
					Additional Information
				</h2>
				<RenderLinkGroups
					groups={additionalInformationGroups}
					colSpan={colSpan}
					defaultExpanded={true}
				/>
			</div>
		</>
	);
};

export default HomePageBody;
